import React from 'react';
import WrapperComponent from '../commonComponents/WrapperComponent';

const NotAuthorized = () => {
    return (
        <WrapperComponent>
            <div className="container text-center mt-5">
                <h2 className="text-danger">403 - Not Authorized</h2>
                <p>You do not have permission to access this page.</p>
            </div>
        </WrapperComponent>
    )
};

export default NotAuthorized;